import Mission from '../Mission';
import '../styles/Mission.css';

const Missions = () => (
  <div className="mission">
    <Mission />
  </div>
);

export default Missions;
